module.exports = __webpack_public_path__ + "static/img/logo_login@2x.0eeb1465.png";